module.exports = __webpack_public_path__ + "static/media/gridWhite.713c9c08.svg";